<template>
  <div id="app">
      <router-view></router-view>
      <Footer/>
  </div>
</template>

<script>
import Footer from './common/Footer'
export default {
  name: 'app',
  components: {
    Footer
  },
  data() {
    return {
      status:0
    };
  },
  methods: {
    getBaseInfo(){
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res=>{
        if(!localStorage.getItem('token')){
          this.$router.push({path:'/Login'})
        }
        this.$store.commit('setBaseInfoValue', res.data);
      })
    }

  },
  created(){
    this.getBaseInfo();
	
  }
}
</script>

<style>
body .van-toast {
  font-size: 0.85rem !important;
  padding: 0.7rem 0.9rem !important;
  line-height: 1.2rem !important;
  width: auto !important;
  max-width: 80% !important;
  min-width: 12rem !important;
}
body .van-toast .van-toast__text {
  font-size: 0.9rem !important;
  line-height: 1.2rem !important;
}
body .van-toast .van-toast__icon {
  font-size: 1rem !important;
  margin-bottom: 0.3rem !important;
}
body .van-toast--success .van-toast__icon,
body .van-toast--fail .van-toast__icon {
  font-size: 1rem !important;
}
*, :after, :before {
  box-sizing: border-box;
}
</style>
